export default function getDeviceLanguage (): {short: 'it' | 'de' | 'en', long: string}{
    let language: string = navigator.language || '';

    if(language.toLocaleLowerCase().includes('it-')) return {short: 'it', long: 'Italiano'};
    if(language.toLocaleLowerCase().includes('de-')) return {short: 'de', long: 'Deutsch'};
    if(language.toLocaleLowerCase().includes('en-')) return {short: 'en', long: 'English'};

    return {short: 'it', long: 'Italiano'}; //default language
}